/**
 * IT > API docs (/it/api-docs). A launch page for the API's interactive
 * documentation (Swagger UI), served by the api at `${API_BASE}/docs`, so the
 * link follows the stage (dev docs on dev, prod docs on prod). The docs need a
 * signed-in session (api #712); the browser already holds it on the shared
 * .ampersandbrands.com cookie, so the new tab opens signed in. Gated by
 * `it.api-docs` in the catalog.
 */

import { ExternalLink } from 'lucide-react';
import { ToolPinToggle } from '@/components/ToolPinToggle';
import { API_BASE } from '@/lib/apiBase';

export const API_DOCS_URL = `${API_BASE}/docs`;

export function ApiDocs() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="mb-6 flex items-start justify-between gap-4">
        <div>
          <p className="mb-1 text-xs uppercase tracking-wide text-amp-olive dark:text-amp-olive-dark">
            IT - API docs
          </p>
          <h1 className="text-2xl font-semibold text-amp-ink dark:text-amp-dark-ink">API docs</h1>
          <p className="mt-1 max-w-2xl text-sm text-amp-ink-muted dark:text-amp-dark-ink-muted">
            Every API endpoint behind Cockpit and The Sweet Spot, with what it does, the access it
            needs, and a way to try it. Opens in a new tab, signed in as you.
          </p>
        </div>
        <ToolPinToggle toolSlug="api-docs" toolName="API docs" />
      </div>
      <div>
        <a
          href={API_DOCS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded bg-amp-ink px-4 py-2 text-sm font-medium text-amp-white hover:opacity-90 dark:bg-amp-dark-ink dark:text-amp-dark-surface"
        >
          <ExternalLink className="h-4 w-4" aria-hidden /> Open API docs
        </a>
      </div>
    </div>
  );
}
